export const FooterIcon = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 548 160" {...props}>
    <path
      d="M540.124 3.16157C537.023 1.23983 533.736 0.247966 530.449 0.247966C525.115 0.247966 519.968 2.72762 515.874 7.31499C471.345 56.6602 376.269 88.5238 273.628 88.5238C170.987 88.5238 76.4075 56.6602 31.9399 7.31499C27.7846 2.60364 22.575 0 17.3034 0C13.7683 0 10.3573 1.17784 7.44238 3.34754C-0.682106 9.4227 -2.35662 20.0232 3.41115 29.074C55.197 109.849 158.707 160 273.566 160C388.425 160 493.609 109.787 544.403 29.012C550.481 19.5273 548.682 8.86478 540.124 3.16157Z"
      fill="#555B99"
    />
  </svg>
);
